import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { Button, makeStyles, Tooltip } from '@material-ui/core';
import { Add } from '@material-ui/icons';

import { DialogDatagrid } from '../../common/dialogs/DialogDatagrid';
import { CreateResourceDialog, EditResourceDialog } from '../../common/dialogs/ResourceDialog';

import { GroupForm } from './GroupForm';

const useStyles = makeStyles((theme) => ({
  tooltip: {
    maxWidth: 750,
  },
}));

const AddGroupDialog = props =>
  <CreateResourceDialog label="resources.groups.actions.add" resource="groups" basePath="/groups" {...props}>
    <GroupForm />
  </CreateResourceDialog>

const EditGroupDialog = props =>
  <EditResourceDialog label="resources.groups.labels.edit" resource="groups" basePath="/groups" {...props}>
    <GroupForm />
  </EditResourceDialog>

export const AddGroupButton = ({ size, variant, isGroups, ...props }) => {
  const translate = useTranslate();
  const [ isOpen, setOpen ] = useState(false);
  const classes = useStyles();

  const addButton = (
    <Button disabled={!isGroups} color="primary" size={size} variant={variant} startIcon={<Add />} onClick={() => setOpen(true)}>
      {translate('resources.groups.actions.add')}
    </Button>
  );

  return <>
    {!isGroups ? <Tooltip
      title={<div dangerouslySetInnerHTML={{ __html: `${translate("resources.pools.tooltips.groups_unavailable")}${translate('resources.officeSettings.tooltips.groupingType')}` }} />}
      placement="center"
      classes={{ tooltip: classes.tooltip }}
    >
      <span>{addButton}</span>
    </Tooltip>
      : <span>{addButton}</span>}
    <AddGroupDialog isOpen={isOpen} handleClose={() => setOpen(false)} {...props} />
  </>
}

export const GroupDatagrid = props => <DialogDatagrid dialog={EditGroupDialog} {...props} />
